import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { environment } from 'environments/environment';
import { User } from '@classes/user';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/user';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getUsers(): Observable<Array<User>> {
    return this.http.get<Array<User>>(this.basePath);
  }

  createOrUpdateUser(user?: User): Observable<User> {
    if (user && !user?.company?.id) {
      user.company = null;
    }
    if (user?.id) {
      //update
      const url = `${this.basePath}/${user?.id}`;
      return this.http.patch<any>(url,
        user).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        user
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteUser(userId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${userId}`;
    return this.http.delete(url);
  }

}
